import { FaMedal, FaUser } from "react-icons/fa";
import { FaHouse, FaMasksTheater } from "react-icons/fa6";

import { Spinner } from "@heroui/react";
import { cn } from "@heroui/theme";

import { Link, useLocation, useNavigation } from "@remix-run/react";
import { motion } from "framer-motion";
import { useUser } from "@clerk/remix";

const tabs = [
  {
    key: "home",
    icon: <FaHouse className="text-2xl" />,
    label: "Home",
    route: "/",
  },
  {
    key: "community",
    icon: <FaMasksTheater className="text-2xl" />,
    label: "Community",
    route: "/community",
  },

  {
    key: "leaderboard",
    icon: <FaMedal className="text-2xl" />,
    label: "Leaderboard",
    route: "/leaderboard",
  },

  {
    key: "me",
    icon: <FaUser className="text-2xl" />,
    label: "Me",
    route: "/me",
  },
];

export const BottomNavBar = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { isSignedIn } = useUser();

  const currentTab =
    tabs.find(
      (tab) => pathname === tab.route || pathname.startsWith(tab.route + "/")
    ) || tabs[0]; // Default to home if no match
  const navigation = useNavigation();
  const isTabRoute = tabs.some(
    (tab) => pathname === tab.route || pathname.startsWith(tab.route + "/")
  );
  if (!isTabRoute || !isSignedIn) {
    return null;
  }

  return (
    <div className="w-full flex flex-row justify-center items-center border-t-2 border-neutral-700">
      <div className="flex flex-row justify-between items-center w-full max-w-2xl bg-neutral-950 px-5 pb-1">
        {tabs.map((tab) => (
          <Link to={tab.route} key={tab.key}>
            <motion.div
              initial={false}
              animate={{
                color: "white",
              }}
              key={tab.key}
              className={cn("rounded-3xl px-5 py-2 relative")}
            >
              {/* {tab.key === currentTab.key && (
                <motion.div
                  layoutId="background"
                  className="absolute inset-0 rounded-3xl"
                  style={{
                    backgroundColor: "black",
                    boxShadow:
                      currentTab.key === tab.key
                        ? "0px 4px 4px rgba(255, 255, 255, 0.4) inset"
                        : "",
                  }}
                />
              )} */}
              {/* 
              <motion.div
                className="absolute inset-0 rounded-3xl opacity-20"
                style={{
                  backgroundColor:
                    navigation.state === "loading" &&
                    navigation.location.pathname === tab.route
                      ? "black"
                      : "transparent",
                  boxShadow:
                    currentTab.key === tab.key
                      ? "0px 4px 4px rgba(255, 255, 255, 0.4) inset"
                      : "",
                }}
              /> */}

              <motion.div
                className={cn(
                  "relative z-10 flex flex-col justify-center item-center border-2 border-transparent rounded-xl p-2",

                  tab.key === currentTab.key ? "border-white/70" : ""
                )}
              >
                {navigation.state === "loading" &&
                navigation.location.pathname === tab.route ? (
                  <Spinner
                    color="white"
                    // classNames={{
                    //   base: "grayscale-100",
                    // }}
                    variant="wave"
                    className="h-4 w-4"
                  />
                ) : (
                  <>{tab.icon}</>
                )}
              </motion.div>
            </motion.div>
          </Link>
        ))}
      </div>
    </div>
  );
};
